
/**
 * @public
 */
export interface RenderTargetOptions {
  width: number,
  height: number,
  depthFormat?: number
}
